/* eslint-disable no-unused-vars */
import Vue from 'vue';
import Vuex from 'vuex';
//import pathify from 'vuex-pathify'
//import LoyaltyHubStore from './modules/loyaltyhub.module';
import axios from "axios";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)
const apiURL = process.env.VUE_APP_LOYALTY_API_URI;
//console.log(apiURL);

export default new Vuex.Store({
            state: {
                custInfo: {},
                isSuccess: false,
                custInfoByDomain: {},
                profile: {},
                lineInfo: {},
                rewards: [],
                reward: {},
                products: [],
                redeem: {
                    temp: {},
                    history: [],
                    list: []
                },
                orderList: [],
                orderHistory: [],
                logged: false,
                cart: [],
                contents: [],
                province: [],
                postcode: [],
                postcodeProvinceData: [],

            },
            //----------------
            actions: {
                preparePostcodeProvinceData: async ({
                    commit,
                    state
                }) => {
                    try {
                        let payload = {
                            createBy: localStorage.getItem("email"),
                            updateBy: localStorage.getItem("email"),
                            custId: localStorage.getItem("custId"),

                            type: "postcode",
                            filter: "",
                        };
                        await axios
                            .post(
                                apiURL + "/v1/zipcode/getZipcodeData",
                                payload, // need to change
                                {
                                    headers: {
                                        // Overwrite Axios's automatically set Content-Type
                                        "Content-Type": "application/json",
                                        //token: localStorage.getItem("token"),
                                        'Accept': 'application/json, text/plain, */*',
                                    'Authorization': 'Basic b2dmOiFxYXpYU1dA',
                                    'Access-Control-Allow-Origin': '*',
                                    'Access-Control-Allow-Credentials': true,
                                    },
                                }
                            )
                            .then((response) => {
                                console.log(response.data);
                                commit("PREPARE_POSTCODE_PROVINCE", response.data);
                            });
                    } catch (err) {
                        /*{
                          status: "Error",
                          code: 500,
                          message: err,
                        };
                        */
                        console.log(err);
                    }
                },
                resetState: ({
                    commit
                }) => {
                    commit("RESET_STATE");
                },
                addMember: async ({
                    commit,
                    state
                }, payload) => {
                    payload.hubspot_email = payload.email
                    //alert(payload.line_id)
                    //alert("URL: "+ apiURL + "/v1/clients/create")
                    try {
                        await axios.post(apiURL + "/v1/clients/create",
                            payload, // need to change
                            {
                                headers: {
                                    // Overwrite Axios's automatically set Content-Type

                                    'Accept': 'application/json, text/plain, */*',
                                    'Authorization': 'Basic b2dmOiFxYXpYU1dA',
                                    'Access-Control-Allow-Origin': '*',
                                    'Access-Control-Allow-Credentials': true,


                                },
                            }).then((response) => {
                            //alert(JSON.stringify(response));
                            if (response.data._id !== undefined) {
                                commit("REGISTER", response.data)
                                state.isSuccess = true

                            } else {
                                state.isSuccess = false
                            }

                        })
                    } catch (err) {
                        state.isSuccess = false
                    }
                },
                updateMember: async ({
                    commit,
                    state
                }, payload) => {
                    payload.hubspot_email = payload.email
                    //alert(payload.line_id)
                    //alert("URL: "+ apiURL + "/v1/clients/create")
                    try {
                        await axios.put(apiURL + "/v1/clients/update",
                            payload, // need to change
                            {
                                headers: {
                                    // Overwrite Axios's automatically set Content-Type

                                    'Accept': 'application/json, text/plain, */*',
                                    'Authorization': 'Basic b2dmOiFxYXpYU1dA',
                                    'Access-Control-Allow-Origin': '*',
                                    'Access-Control-Allow-Credentials': true,


                                },
                            }).then((response) => {
                            //alert(JSON.stringify(response));
                            if (response.data.ok == 1) {
                                commit("REGISTER", payload)
                                state.isSuccess = true

                            } else {
                                state.isSuccess = false
                            }

                        })
                    } catch (err) {
                        state.isSuccess = false
                    }
                },
                checkExistedMember: ({
                    commit
                }, payload) => {
                    console.log('checkExistedMember')

                    return new Promise((resolve, reject) => {
                        axios.post(apiURL + "/v1/clients/findByLineID",
                            payload, // need to change
                            {
                                headers: {
                                    // Overwrite Axios's automatically set Content-Type

                                    'Accept': 'application/json, text/plain, */*',
                                    'Authorization': 'Basic b2dmOiFxYXpYU1dA',
                                    'Access-Control-Allow-Origin': '*',
                                    'Access-Control-Allow-Credentials': true,


                                },
                            }).then((response) => {
                            console.log(response)

                            //return response.data;
                            if (response.status == 200) {
                                commit("SET_PROFILE", response.data);
                                resolve(response.data);
                            } else {
                                reject(response.data);
                            }
                            //}
                        }).catch(err => {
                            reject(err);
                        });
                    });




                },
                setLineProfile: ({
                    commit
                }, payload) => {
                    commit("SET_LINE_PROFILE", payload);
                },
                setLogged: ({
                    commit
                }, payload) => {
                    commit("SET_LOGGED", payload)
                },
                listRewards: async ({
                    commit
                }, payload) => {
                    try {
                        const list = await axios.get(apiURL + '/v1/rewards/member/list', {
                            headers: {
                                // Overwrite Axios's automatically set Content-Type

                                'Accept': 'application/json, text/plain, */*',
                                'Authorization': 'Basic b2dmOiFxYXpYU1dA',
                                'Access-Control-Allow-Origin': '*',
                                'Access-Control-Allow-Credentials': true,


                            },
                            params: payload
                        })

                        console.log(list.data.data);

                        commit("LIST_REWARDS", list.data.data);
                        //commit("SET_TOTAL_ITEMS", list.data.totalItems);

                    } catch (err) {
                        return err
                    }
                },
                //--------------------------------------


                getCustInfoByDomain: async ({
                    commit
                }, payload) => {
                    let domain = window.location.hostname;
                    try {
                        const list = await axios.get(apiURL + '/v1/customers/info/' + domain, {
                            headers: {
                                // Overwrite Axios's automatically set Content-Type

                                'Accept': 'application/json, text/plain, */*',
                                'Authorization': 'Basic b2dmOiFxYXpYU1dA',
                                'Access-Control-Allow-Origin': '*',
                                'Access-Control-Allow-Credentials': true,


                            },
                            params: payload
                        })
                        // console.log("getCustInfoByDomain");
                        // console.log(list.data.data);

                        commit("SET_CUSTOMERINFO_DOMAIN", list.data.data);
                        //commit("SET_TOTAL_ITEMS", list.data.totalItems);

                    } catch (err) {
                        console.log(err)
                        return err
                    }
                },
                //-----------------------------------------
                getRewardInfo: ({
                    commit,
                    state
                }, payload) => {
                    return new Promise((resolve, reject) => {
                        try {
                            state.reward = {}
                            axios.get(apiURL + '/v1/rewards/' + payload, {
                                headers: {
                                    // Overwrite Axios's automatically set Content-Type

                                    'Accept': 'application/json, text/plain, */*',
                                    'Authorization': 'Basic b2dmOiFxYXpYU1dA',
                                    'Access-Control-Allow-Origin': '*',
                                    'Access-Control-Allow-Credentials': true,


                                }

                            }).then(list => {

                                console.log(list.data);

                                commit("REWARD_INFO", list.data);
                                resolve(list.data);
                                //return list.data;
                                //commit("SET_TOTAL_ITEMS", list.data.totalItems);

                            });
                        } catch (err) {
                            reject(err)
                        }
                    });
                },
                decreaseRewardQuantity: ({
                    commit
                }, index) => {
                    commit("DECREASE_REWARD_QUANTITY", index)
                },

                // redeem
                createRedeem: ({
                    commit
                }, payload) => {
                    return new Promise((resolve, reject) => {
                        try {
                            axios.post(apiURL + "/v1/redeem/create",
                                payload, // need to change
                                {
                                    headers: {
                                        // Overwrite Axios's automatically set Content-Type

                                        'Accept': 'application/json, text/plain, */*',
                                        'Authorization': 'Basic b2dmOiFxYXpYU1dA',
                                        'Access-Control-Allow-Origin': '*',
                                        'Access-Control-Allow-Credentials': true,


                                    }
                                }).then((response) => {

                                commit("TEMP_REDEEM", response.data);
                                resolve(response.data)

                            })

                        } catch (err) {
                            reject(err)
                        }
                    });

                },
                cancelRedeem: ({
                    commit
                }, payload) => {
                    return new Promise((resolve, reject) => {
                        try {
                            axios.put(apiURL + "/v1/redeem/cancel",
                                payload, // need to change
                                {
                                    headers: {
                                        // Overwrite Axios's automatically set Content-Type

                                        'Accept': 'application/json, text/plain, */*',
                                        'Authorization': 'Basic b2dmOiFxYXpYU1dA',
                                        'Access-Control-Allow-Origin': '*',
                                        'Access-Control-Allow-Credentials': true,


                                    }
                                }).then((response) => {
                                console.log(response)
                                //alert('check existed')
                                //alert(JSON.stringify(response));
                                //if(response.status == 200){
                                commit("RESET_TEMP_REDEEM")
                                resolve(response.data);
                                //}

                            })
                        } catch (err) {
                            reject(err)
                        }
                    });

                },
                redeemHistory: async ({
                    commit
                }, payload) => {
                    try {
                        const list = await axios.get(apiURL + '/v1/redeem/list/member/' + payload.id, {
                            headers: {
                                // Overwrite Axios's automatically set Content-Type

                                'Accept': 'application/json, text/plain, */*',
                                'Authorization': 'Basic b2dmOiFxYXpYU1dA',
                                'Access-Control-Allow-Origin': '*',
                                'Access-Control-Allow-Credentials': true,


                            },
                            params: payload
                        })
                        console.log(list.data.data);

                        commit("REDEEM_HISTORY", list.data.data);
                        //commit("SET_TOTAL_ITEMS", list.data.totalItems);

                    } catch (err) {
                        return err
                    }
                },


                getRedeemInformation: ({
                    commit
                }, payload) => {
                    //let info = payload;

                    return new Promise((resolve, reject) => {
                                console.log(payload);
                                if (payload !== undefined) {
                                    axios.get(apiURL + "/v1/redeem/get/" + payload, // need to change
                                        {
                                            headers: {
                                                // Overwrite Axios's automatically set Content-Type

                                                'Accept': 'application/json, text/plain, */*',
                                                'Authorization': 'Basic b2dmOiFxYXpYU1dA',
                                                'Access-Control-Allow-Origin': '*',
                                                'Access-Control-Allow-Credentials': true,


                                            }
                                        }).then((response) => {
                                            console.log(response);
                                            if (response.status == 200) {

                                                resolve(response.data);
                                            } else {
                                                reject(response.data);
                                            }



                                        }).catch(error => {
                                            // request failed
                                            reject(error) // return error to calling function
                                        })
                                    }
                                    else {
                                        reject({
                                            "error": ""
                                        });
                                    }

                                });



                        },
                        //------------------- product
                        listProducts: async ({
                                commit
                            }, payload) => {
                                console.log('list product');
                                console.log(payload);
                                try {
                                    const list = await axios.get(apiURL + '/v1/products/list', {
                                        headers: {
                                            // Overwrite Axios's automatically set Content-Type

                                            'Accept': 'application/json, text/plain, */*',
                                            'Authorization': 'Basic b2dmOiFxYXpYU1dA',
                                            'Access-Control-Allow-Origin': '*',
                                            'Access-Control-Allow-Credentials': true,


                                        },
                                        params: payload
                                    })
                                    commit("LIST_PRODUCTS", list.data.data);
                                } catch (err) {
                                    return err
                                }
                            },


                            add2Cart: ({
                                commit
                            }, payload) => {
                                commit("ADD2CART", payload)
                            },
                            updateCart: ({
                                commit
                            }, {
                                payload,
                                index
                            }) => {
                                commit("UPDATE_CART", {
                                    payload,
                                    index
                                })
                            },
                            removeCart: ({
                                commit
                            }, index) => {
                                commit("REMOVE_CART", index)
                            },
                            cancelOrder: ({
                                commit
                            }) => {
                                commit("CLEAR_CART");
                            },

                            //-------------------------
                            // Get sale information
                            getSaleInformation: ({
                                commit
                            }, payload) => {
                                //let info = payload;

                                return new Promise((resolve, reject) => {
                                    console.log(payload);
                                    if (payload._id !== undefined) {
                                        axios.get(apiURL + "/v1/orders/" + payload._id, {
                                                params: payload._id
                                            }, // need to change
                                            {
                                                headers: {
                                                    // Overwrite Axios's automatically set Content-Type

                                                    'Accept': 'application/json, text/plain, */*',
                                                    'Authorization': 'Basic b2dmOiFxYXpYU1dA',
                                                    'Access-Control-Allow-Origin': '*',
                                                    'Access-Control-Allow-Credentials': true,


                                                }
                                            }).then((response) => {
                                            console.log(response);
                                            if (response.status == 200) {

                                                resolve(response.data);
                                            } else {
                                                reject(response.data);
                                            }



                                        }).catch(error => {
                                            // request failed
                                            reject(error) // return error to calling function
                                        })
                                    } else {
                                        reject({
                                            "error": ""
                                        });
                                    }

                                });



                            },

                            //-------------------------
                            saveOrder: async ({
                                    commit,
                                    state
                                }, payload) => {
                                    try {
                                        await axios.post(apiURL + "/v1/orders/save", {
                                                ...payload,
                                                products: state.cart.filter(item => {
                                                    return item.custId == localStorage.getItem("custId") && item.custId !== undefined
                                                }),
                                                memberId: state.profile._id
                                            }, // need to change
                                            {
                                                headers: {
                                                    // Overwrite Axios's automatically set Content-Type

                                                    'Accept': 'application/json, text/plain, */*',
                                                    'Authorization': 'Basic b2dmOiFxYXpYU1dA',
                                                    'Access-Control-Allow-Origin': '*',
                                                    'Access-Control-Allow-Credentials': true,


                                                }
                                            }).then((response) => {
                                            if (response.data.code == 0) {
                                                commit("CLEAR_CART");
                                            }


                                        })
                                    } catch (err) {
                                        return err
                                    }

                                },

                                updateAttachment: ({
                                    commit,
                                    state
                                }, payload) => {


                                    return new Promise((resolve, reject) => {
                                        // Do something here... lets say, a http call using vue-resource
                                        axios.put(apiURL + "/v1/orders/update/attachment", {
                                                ...payload,
                                                memberId: state.profile._id
                                            }, // need to change
                                            {
                                                headers: {
                                                    // Overwrite Axios's automatically set Content-Type

                                                    'Accept': 'application/json, text/plain, */*',
                                                    'Authorization': 'Basic b2dmOiFxYXpYU1dA',
                                                    'Access-Control-Allow-Origin': '*',
                                                    'Access-Control-Allow-Credentials': true,


                                                }
                                            }).then((response) => {
                                            console.log(response)
                                            if (response.data.code == 0) {
                                                let responseData = response.data.data
                                                commit("UPDATE_ATTACHMENT", {
                                                    responseData,
                                                    payload
                                                });
                                                resolve(responseData);
                                            } else {
                                                reject({
                                                    response
                                                });
                                            }



                                        })
                                        // http success, call the mutator and change something in state
                                        // Let the calling function know that http is done. You may send some data back
                                    })




                                },

                                // customer information
                                getCustInfoById: async ({
                                        commit
                                    }, payload) => {
                                        try {
                                            console.log("getCustInfoByLiffId");
                                            let response = await axios.get(apiURL + "/v1/customers/" + payload.liffId, {
                                                headers: {
                                                    // Overwrite Axios's automatically set Content-Type

                                                    'Accept': 'application/json, text/plain, */*',
                                                    'Authorization': 'Basic b2dmOiFxYXpYU1dA',
                                                    'Access-Control-Allow-Origin': '*',
                                                    'Access-Control-Allow-Credentials': true,


                                                }
                                            })
                                            //console.log(response);
                                            if (response.status == 200) {
                                                if (response.data.data.apiKey != "" || response.data.data.apiKey !== undefined) {
                                                    localStorage.setItem("apiKey", response.data.data.apiKey || null);
                                                    localStorage.setItem("custId", response.data.data.custId || null);
                                                    localStorage.setItem("liffId", response.data.data.liffId || null);
                                                }
                                                commit("SET_CUSTOMER_INFO", response.data.data);
                                            }
                                            // })
                                        } catch (err) {
                                            return err
                                        }

                                    },

                                    getCustInfoByLiffId: async ({
                                            commit
                                        }, payload) => {
                                            try {
                                                console.log("getCustInfoByLiffId");
                                                let response = await axios.get(apiURL + "/v1/customers/liffId/" + payload, {
                                                    headers: {
                                                        // Overwrite Axios's automatically set Content-Type

                                                        'Accept': 'application/json, text/plain, */*',
                                                        'Authorization': 'Basic b2dmOiFxYXpYU1dA',
                                                        'Access-Control-Allow-Origin': '*',
                                                        'Access-Control-Allow-Credentials': true,


                                                    }
                                                })
                                                //console.log(response);
                                                if (response.status == 200) {
                                                    //localStorage.setItem("apiKey", response.data.data.apiKey || null);
                                                    //localStorage.setItem("custId", response.data.data.custId || null);
                                                    if (response.data.data.apiKey != "" || response.data.data.apiKey !== undefined) {
                                                        localStorage.setItem("apiKey", response.data.data.apiKey || null);
                                                        localStorage.setItem("custId", response.data.data.custId || null);
                                                        //localStorage.setItem("liffId", response.data.data.liffId || null);
                                                    }
                                                    commit("SET_CUSTOMER_INFO", response.data.data);
                                                }
                                                // })
                                            } catch (err) {
                                                return err
                                            }

                                        },
                                        orderList: async ({
                                                commit
                                            }, {
                                                payload,
                                                memberId
                                            }) => {
                                                try {
                                                    const list = await axios.get(apiURL + '/v1/orders/member/' + memberId + '/list', {
                                                        headers: {
                                                            // Overwrite Axios's automatically set Content-Type

                                                            'Accept': 'application/json, text/plain, */*',
                                                            'Authorization': 'Basic b2dmOiFxYXpYU1dA',
                                                            'Access-Control-Allow-Origin': '*',
                                                            'Access-Control-Allow-Credentials': true,


                                                        },
                                                        params: payload
                                                    })

                                                    commit("ORDER_LIST", list.data.data);
                                                    //commit("SET_TOTAL_ITEMS", list.data.totalItems);

                                                } catch (err) {
                                                    return err
                                                }
                                            },


                                            pendingOrder: async ({
                                                    commit
                                                }, {
                                                    payload,
                                                    memberId
                                                }) => {
                                                    try {
                                                        const list = await axios.get(apiURL + '/v1/orders/member/' + memberId + '/list', {
                                                            headers: {
                                                                // Overwrite Axios's automatically set Content-Type

                                                                'Accept': 'application/json, text/plain, */*',
                                                                'Authorization': 'Basic b2dmOiFxYXpYU1dA',
                                                                'Access-Control-Allow-Origin': '*',
                                                                'Access-Control-Allow-Credentials': true,


                                                            },
                                                            params: payload
                                                        })

                                                        commit("ORDER_LIST", list.data.data);
                                                        //commit("SET_TOTAL_ITEMS", list.data.totalItems);

                                                    } catch (err) {
                                                        return err
                                                    }
                                                },
                                                setContent: async ({
                                                    commit
                                                }, payload) => {
                                                    //
                                                    console.log('setContent');
                                                    console.log(payload);
                                                    try {
                                                        const contents = await axios.get(apiURL + '/v1/contents/list', {
                                                            headers: {
                                                                // Overwrite Axios's automatically set Content-Type

                                                                'Accept': 'application/json, text/plain, */*',
                                                                'Authorization': 'Basic b2dmOiFxYXpYU1dA',
                                                                'Access-Control-Allow-Origin': '*',
                                                                'Access-Control-Allow-Credentials': true,


                                                            },
                                                            params: payload
                                                        })
                                                        commit("SET_CONTENTS", contents.data.data)

                                                    } catch (err) {
                                                        console.log('setContent Error: ' + err);
                                                        return err
                                                    }
                                                }
                },
                //------------
                mutations: {
                    CLEAR_CART: (state) => {
                        state.cart = []
                    },
                    REMOVE_CART: (state, index) => {
                        state.cart.splice(index, 1)
                    },
                    ADD2CART: (state, payload) => {
                        state.cart.push(payload)
                    },
                    UPDATE_CART: (state, {
                        payload,
                        index
                    }) => {
                        state.cart[index] = payload
                    },
                    SET_LINE_PROFILE: (state, payload) => {
                        state.lineInfo = payload;
                    },
                    REGISTER: (state, payload) => {
                        state.profile = payload;
                        state.isSuccess = true;
                    },
                    RESET_SUCCESS: (state) => {
                        state.isSuccess = false;
                    },
                    SET_PROFILE: (state, payload) => {
                        // state.profile = Object.keys(payload).map(function(key){
                        //     console.log('SET_PROFILE');
                        //     console.log(payload[key]);
                        //     payload[key] = key == "birthdate" ? payload[key].substring(0, 10) : payload[key];
                        //     //response.data[key]= key =="genders"? response.data[key].substring(0,10):response.data[key];
                        // })
                        //localStorage.setItem("custId",payload.custId);
                        state.profile = payload
                    },
                    SET_LOGGED: (state, payload) => {
                        state.logged = payload
                    },
                    LIST_REWARDS: (state, payload) => {
                        state.rewards = payload
                    },
                    REWARD_INFO: (state, payload) => {
                        state.reward = {}
                        state.reward = payload
                    },
                    TEMP_REDEEM: (state, payload) => {
                        //let temp = payload

                        state.redeem.temp = payload

                        state.redeem.history.push(payload.data)
                    },
                    REDEEM_HISTORY: (state, payload) => {
                        //let temp = payload
                        state.redeem.history = payload || []
                    },
                    RESET_TEMP_REDEEM: (state) => {
                        state.redeem.temp = {}
                    },
                    DECREASE_REWARD_QUANTITY: (state, index) => {
                        state.rewards[index].quantity = state.rewards[index].quantity - 1
                    },
                    //------------
                    LIST_PRODUCTS: (state, payload) => {
                        state.products = payload
                    },

                    SET_CUSTOMER_INFO: (state, payload) => {
                        state.custInfo = payload
                    },

                    RESET_STATE: (state) => {
                        state = {
                            custInfo: {},
                            isSuccess: false,
                            custInfoByDomain: {},
                            profile: {},
                            lineInfo: {},
                            rewards: [],
                            products: [],
                            redeem: {
                                temp: {},
                                history: [],
                                list: []
                            },
                            orderList: [],
                            logged: false,
                            cart: [],
                            contents: []

                        }
                    },
                    ORDER_LIST: (state, payload) => {
                        state.orderList = payload || []
                    },


                    UPDATE_ATTACHMENT: (state, {
                        payload,
                        index
                    }) => {
                        state.orderList[state.orderList.indexOf(index)] = payload
                    },


                    //CONTENTS
                    SET_CONTENTS: (state, payload) => {
                        state.contents = payload || []
                    },

                    //PREPARE DATA
                    PREPARE_POSTCODE_PROVINCE: (state, payload) => {

                        state.postcodeProvinceData = payload;
                    },

                    //-------------
                    SET_CUSTOMERINFO_DOMAIN: (state, payload) => {
                        localStorage.setItem("apiKey", payload.apiKey);
                        localStorage.setItem("custId", payload.custId);
                        localStorage.setItem("liffId", payload.liffId);
                        state.custInfoByDomain = payload
                    },


                },
                //--------------
                getters: {
                    profile: (state) => {
                        return state.profile;
                    }
                },
                plugins: [createPersistedState()]
            })